import { render, staticRenderFns } from "./CatalogoDigitalOrderPoller.vue?vue&type=template&id=450155d2"
import script from "./CatalogoDigitalOrderPoller.vue?vue&type=script&lang=js"
export * from "./CatalogoDigitalOrderPoller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports